import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { ICCService } from '../../icc.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
const _ = require('lodash');
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';

export interface ModelIPRange {
    ipRange: {
        start: string,
        end: string
    },
    isValid: boolean
}

@Component({
    selector: 'network-profile',
    styles: [require('../../icc.scss')],
    template: require('./network-profile.html'),
    providers: [
        ICCService, TranslateService
    ]
})

export class NetworkProfile {
    @Input() editData: any;
    @Input() backingList: any;
    @Input() showAddCloseButton: boolean = true;
    @Input() isWizardOpen: boolean = false;
    @Input() isEdit: boolean = false;
    @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

    @Output() fireValidity = new EventEmitter();
    @Output() networkProfileEmitter = new EventEmitter();

    private subscribeHandler;
    private isTranslationready: boolean = true;
    private vcList: Array<Object>;
    private deploymentContainerList: Array<Object>;

    private isLoading: boolean = false;
    private selectedVCUUID: string = ''
    private isIpRangeValid: false;
    private newIPRanges;
    private ipRangeText: string = '';

    // private selected = [];
    private ipValidationUtils : IpValidationUtils = new IpValidationUtils();

    private networkTypes = [
        { key: 'vmotionNetwork', title: 'VMotion Network', selected: false },
        { key: 'externalNetwork', title: 'External Network', selected: false },
        { key: 'managementNetwork', title: 'Management Network', selected: false },
        { key: 'directConnectNetwork1', title: 'Direct Connect Network 1', selected: false },
        { key: 'directConnectNetwork2', title: 'Direct Connect Network 2', selected: false }
    ]

    private dataModel = {
        gatewayAddress: '',
        maskBits: '',
        startAddress: '',
        endAddress: '',
        dvpgId: 'select',
        dvpgName: '',
        networkTypes: _.cloneDeep(this.networkTypes),
        isValid: false,
        isIPAddressValid: false,
        ipRangeText: '',
        isWANActive: false,
        isLANActive: true
    };

    private objectKeys = Object.keys;
    private networkProfileData: any[] = [_.cloneDeep(this.dataModel)];

    ngOnInit() {
        // this.getVCList();

    }

    ngOnChanges(changes) {
        // console.log("BB", this.backingList)
        if (this.backingList) {
            // this.dataModel['backingList'] = _.cloneDeep(this.backingList);
            // console.log ('DM', this.dataModel)
        }
    }

    constructor(public appState: AppState,
        public service: ICCService,
        private translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    getDVPGName(id) {
        let entity = this.backingList.dvpgs.find(item => item.entity_id === id);
        if (entity) {
            return entity.name;
        }
        return '';
    }
    onSelectDVPGChange(form, item, event) {
        if (event) {
            item.dvpgId = event;
            item.dvpgName = this.getDVPGName(event);
            this.checkFormValid(form, item);
        } else {
            this.clearForm(item);
        }
    }

    clearForm(networkProfile) {
        networkProfile.gatewayAddress =  ''
        networkProfile.maskBits = '',
        networkProfile.startAddress = '',
        networkProfile.endAddress = '',
        networkProfile.dvpgId = '',
        networkProfile.networkTypes.forEach(function (item) {
            item.selected = false;
        });
    }
    checkFormValid(form?, item?) {
        // this.isValid = this.isFormValid() ? true : false;
        // /console.log ("DM", this.dataModel, this.networkTypes);
        setTimeout(() => {

            if (form && item) {
                // console.log ("valid", form.valid);
                item.isValid = form.valid;
            }


            let isGlobalValid: boolean = true;
            for (let i = 0; i < this.networkProfileData.length; i++) {
                if (this.networkProfileData[i].isValid) {
                    isGlobalValid = isGlobalValid && this.networkProfileData[i].isValid && this.networkProfileData[i].isIPAddressValid && this.isTagSelected(this.networkProfileData[i].networkTypes);
                } else {
                    isGlobalValid = false;
                }
            }
                this.networkProfileEmitter.emit(
                    {
                        stepId: 1,
                        data: this.networkProfileData,
                        isGlobalValid: isGlobalValid
                    }
                );

        }, 10);


    }


    add(event, i: number, value: any) {
        this.networkProfileData.push(_.cloneDeep(this.dataModel));
        this.networkProfileEmitter.emit(
            {
                stepId: 1,
                isGlobalValid: false,
                data: this.networkProfileData
            }
        );

    }

    remove(event, i: number) {
        this.networkProfileData.splice(i, 1);
        if (this.networkProfileData.length === 0) {
            this.networkProfileEmitter.emit(
                {
                    stepId: 1,
                    isGlobalValid: false,
                    data: this.networkProfileData
                }
            );
            return;
        }
        this.checkFormValid();

    }
    onIpRangeValidation() {

    }

    private isIPAddressValid: boolean = false;

    saveNetworkIPRange(event, item) {
        let __this = this;


        let value: string = event.target.value;
        if (!value) {
            this.isIPAddressValid = false;
            return;
        }
        let formattedIP = this.formatAndValidateIP(value);
        item.startAddress  = formattedIP.ipRange.start;
        item.endAddress  = formattedIP.ipRange.end;
        item.isIPAddressValid = formattedIP.isValid
        if (formattedIP.isValid) {
            item.ipRangeText = this.setIPRangeValue(formattedIP.ipRange)
        }
        this.checkFormValid();

    }

    formatAndValidateIP(value): ModelIPRange {
        let ipRangeArr: string[] = value.split('-', 2);
        let startAddress: string = ipRangeArr[0].trim();
        let endAddress: string = '';
        if (ipRangeArr.length > 1) {
            endAddress = ipRangeArr[1].trim();
        } else {
            endAddress = startAddress;
        }
        let isStartValid: boolean = this.ipValidationUtils.isIpValid(startAddress);
        let isEndValid: boolean = this.ipValidationUtils.isIpValid(endAddress);
        let isStartLtEnd = this.ipValidationUtils.isStartAddressLtEndAddress(startAddress, endAddress);
        let isValid = (isStartValid && isEndValid && isStartLtEnd) ? true : false;
        return {
            ipRange: {
                start: startAddress,
                end: endAddress
            },
            isValid: isValid
        };
    }

    setIPRangeValue(ranges) {
        let ipStr = ranges['start'] + ' - ' + ranges['end'];
        return ipStr.trim();
    }

    isTagSelected(networkProfiles) {
        let isTagPresent: boolean = false;
        networkProfiles.forEach(function(profile) {
            if (profile.selected) {
                isTagPresent = true;
            }
        });
        return isTagPresent;
    }
    onTagChange(item, tag) {
        if (tag === 'LAN') {
            item.networkTypes[1].selected = false;
            item.networkTypes[3].selected = false;
            item.networkTypes[4].selected = false;
            item.isLANActive = true;
            item.isWANActive = false;
        } else {
            item.networkTypes[0].selected = false;
            item.networkTypes[2].selected = false;
            item.isLANActive = false;
            item.isWANActive = true;
        }
        this.checkFormValid();
    }

    onWANChange(item, tag) {
        if (tag === 'internet') {
            item.networkTypes[1].selected = true;
            item.networkTypes[3].selected = false;
            item.networkTypes[4].selected = false;
        }
        if (tag === 'DCN1') {
            item.networkTypes[1].selected = false;
            item.networkTypes[3].selected = true;
            item.networkTypes[4].selected = false;
        }
        if (tag === 'DCN1') {
            item.networkTypes[1].selected = false;
            item.networkTypes[3].selected = false;
            item.networkTypes[4].selected = true;
        }
        this.checkFormValid();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/network-profile/network-profile.component.ts